import request from '@/utils/request'

// 登录 API
export const reqLogin = (loginData) => {
  return request({
    url: '/index/login',
    method: 'post',
    data: loginData
  })
}

// 退出登录 API
export const logout = () => {
  const token = localStorage.getItem('token')
  return request({
    url: '/index/logout',
    method: 'post',
    headers: {
      'token': token
    }
  })
}